import { render, staticRenderFns } from "./SemenDisposal.vue?vue&type=template&id=bfb81e02&scoped=true&"
import script from "./SemenDisposal.vue?vue&type=script&lang=js&"
export * from "./SemenDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb81e02",
  null
  
)

export default component.exports